import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Reset = ({
  height = 17,
  width = 16,
  color = colors.textPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 17" {...props}>
    <path
      d="M12.8865 5.38156C11.4925 2.68279 8.17456 1.62512 5.47579 3.0192C2.77703 4.41328 1.71936 7.73119 3.11344 10.43C4.2876 12.5851 6.16286 13.0774 6.16286 13.0774L5.65234 10.7397C5.56396 10.335 5.82037 9.9353 6.22505 9.84692C6.62973 9.75854 7.02942 10.015 7.1178 10.4196L7.96744 14.3102C8.05582 14.7149 7.79941 15.1146 7.39473 15.203L3.3874 16.0781C2.98273 16.1665 2.58303 15.9101 2.49466 15.5054C2.40628 15.1007 2.6627 14.701 3.06737 14.6127L4.93499 14.2048C4.93499 14.2048 2.91546 13.3914 1.78074 11.1184C0.00646359 7.68358 1.35258 3.46078 4.78738 1.68651C8.22217 -0.0877746 12.445 1.25834 14.2192 4.69314C15.9935 8.12794 14.6474 12.3507 11.2126 14.125C10.1612 14.6681 9.42298 13.3612 10.5242 12.7923C13.223 11.3982 14.2806 8.08033 12.8865 5.38156Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
